export default {"src":"/_next/static/media/offering.777ec7cc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};